import React, { useEffect, useState } from "react";
import { useSidebar } from "../../widgets/sidebar/SidebarContext";
import { Card, CardContainer, CardHeader, CardTitle, CardWrapper, LayoutWraper } from "../style";
import { NotificationList } from "./notificationList";

const NotificationsLayout: React.FC = () => {
    const { sidebar } = useSidebar();

    return (
        <LayoutWraper sidebarOpen={sidebar}>
            <CardWrapper>
                <Card>
                    <CardContainer>
                        <CardHeader>
                            <CardTitle>ОБАВЕШТЕЊА</CardTitle>
                        </CardHeader>
                        <NotificationList />
                    </CardContainer>
                </Card>
            </CardWrapper>
        </LayoutWraper>
    );
};

export default NotificationsLayout;
